import { render } from "./AmountBox.vue?vue&type=template&id=3818738e&scoped=true"
import script from "./AmountBox.vue?vue&type=script&lang=js"
export * from "./AmountBox.vue?vue&type=script&lang=js"

import "./AmountBox.vue?vue&type=style&index=0&id=3818738e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3818738e"]])

export default __exports__